import React, { CSSProperties } from 'react';
import { StyleSheet, StyleProp, TextStyle } from 'react-native';

export interface IconProps {
  name: string;
  size?: number;
  color?: string;
  style?: StyleProp<TextStyle>;
}

// Convert react-native-vector-icons names to Material Icons names
// Material Icons uses underscores, vector-icons uses dashes
const convertIconName = (name: string): string => {
  return name.replace(/-/g, '_');
};

export const Icon: React.FC<IconProps> = ({ name, size = 24, color = '#000', style }) => {
  const flatStyle = style ? StyleSheet.flatten(style) : {};
  // Extract web-compatible CSS properties from RN styles
  const webStyle: CSSProperties = {};

  // Color
  if (flatStyle.color && typeof flatStyle.color === 'string') {
    webStyle.color = flatStyle.color;
  }

  // Margins
  if (typeof flatStyle.margin === 'number') webStyle.margin = flatStyle.margin;
  if (typeof flatStyle.marginTop === 'number') webStyle.marginTop = flatStyle.marginTop;
  if (typeof flatStyle.marginBottom === 'number') webStyle.marginBottom = flatStyle.marginBottom;
  if (typeof flatStyle.marginLeft === 'number') webStyle.marginLeft = flatStyle.marginLeft;
  if (typeof flatStyle.marginRight === 'number') webStyle.marginRight = flatStyle.marginRight;
  if (typeof flatStyle.marginHorizontal === 'number') {
    webStyle.marginLeft = flatStyle.marginHorizontal;
    webStyle.marginRight = flatStyle.marginHorizontal;
  }
  if (typeof flatStyle.marginVertical === 'number') {
    webStyle.marginTop = flatStyle.marginVertical;
    webStyle.marginBottom = flatStyle.marginVertical;
  }

  // Padding
  if (typeof flatStyle.padding === 'number') webStyle.padding = flatStyle.padding;
  if (typeof flatStyle.paddingTop === 'number') webStyle.paddingTop = flatStyle.paddingTop;
  if (typeof flatStyle.paddingBottom === 'number') webStyle.paddingBottom = flatStyle.paddingBottom;
  if (typeof flatStyle.paddingLeft === 'number') webStyle.paddingLeft = flatStyle.paddingLeft;
  if (typeof flatStyle.paddingRight === 'number') webStyle.paddingRight = flatStyle.paddingRight;

  return (
    <span
      className="material-icons"
      style={{
        fontSize: size,
        color,
        width: size,
        height: size,
        lineHeight: `${size}px`,
        display: 'inline-block',
        textAlign: 'center',
        userSelect: 'none',
        ...webStyle,
      }}
    >
      {convertIconName(name)}
    </span>
  );
};

export default Icon;
